import React, { useState } from "react";
import { EmptyStatesConst } from "./EmptyStates.consts";
import { EmptyStateSquare } from "./EmptyStateSquare";
import { EmptyStateTitle, EmptyStateContainer, EmptyStateSquares } from "./EmptyState.styles";
import { PopupModal } from "react-calendly";
import { useStore } from "../../../../../../app/data/root.store";

const filters = {
    1: {
        syncMode: 'bank',
        institutions: [3059, 2956, 2932, 147801, 3468, -1]
    },
    4: {
        syncMode: 'investor',
        institutions: [147131, 147133, 147628, 148001, 147137, -1]
    },
    8: {
        syncMode: 'investor',
        institutions: [147131, 147132, 147135, 147130, 148114, -1]
    }
}

export const EmptyState = ({ filter }) => {
    const { userStore } = useStore();
    const [isCalendlyWidgetOpen, setIsCalendlyWidgetOpen] = useState(false);
    const currFilter = filters[filter];
    if (!currFilter) {
        return null;
    }

    const title = currFilter.syncMode === 'bank' ? 'Sync your bank...' : 'Sync your investor portals...';
    const institutions = currFilter.institutions.map((id) => EmptyStatesConst.find((emptyState) => emptyState.id === id));
    const calendlyUrl = userStore.isB2BUser ? process.env.REACT_APP_B2B_CALENDLY_URL : process.env.REACT_APP_CALENDLY_URL;
    return (
        <EmptyStateContainer>
            <EmptyStateTitle>{title}</EmptyStateTitle>
            <EmptyStateSquares>
                {institutions.map((institution) => <EmptyStateSquare key={institution.id} institution={institution} syncMode={currFilter.syncMode} onBlockedClick={() => setIsCalendlyWidgetOpen(true)}  />)}
            </EmptyStateSquares>
            {isCalendlyWidgetOpen && (
                <PopupModal
                    url={calendlyUrl}
                    rootElement={document.getElementById("root")}
                    onModalClose={() => setIsCalendlyWidgetOpen(false)}
                    open={isCalendlyWidgetOpen}
                />
            )}
        </EmptyStateContainer>
    );
};